// extracted by mini-css-extract-plugin
export var label = "_dq-1";
export var reminder = "_dq-0";